// extracted by mini-css-extract-plugin
export default {"reviewsPage":"Reviews_reviewsPage__ofmJw","reviewsWrapper":"Reviews_reviewsWrapper__dIXcK","reviewsHeader":"Reviews_reviewsHeader__3MCOP"};